import { Link } from 'react-router-dom';
import Header from '@/pages/home/components/Header';
import Footer from '@/pages/home/components/Footer';

const sections = [
  {
    title: '1．個人情報の定義',
    content: `個人情報とは、以下の情報により特定の個人を識別できるもの、または個人識別符号が含まれるものをいいます。\n\n・氏名、年齢、性別、住所、電話番号、職業、メールアドレス\n・個人別に付与されたID、パスワード、その他の記号など\n・その情報のみでは特定の個人を識別できないものの、他の情報と容易に照合することができ、これにより特定の個人を識別できることとなる情報`,
  },
  {
    title: '2．個人情報の収集、利用目的',
    content: `当サイトの個人情報の収集・利用目的は、以下のとおりです。\n\n・当社サービスの提供・運営のため\n・お問い合わせに回答するため\n・情報提供のため\n・上記の利用目的に付随する目的`,
  },
  {
    title: '3．第三者への開示・提供',
    content: `当サイトでは、個人情報の収集は、利用目的を出来る限り特定し、必要範囲でこれを行い、利用目的以外の利用及び提供を行いません。\n但し、以下に該当する場合この限りではありません。\n\n・お客様から同意をいただいた場合\n・法令に基づき開示することが必要である場合\n・不正アクセス、脅迫等の違法行為があった場合\n・その他特別な理由のある場合`,
  },
  {
    title: '4．ご利用者様の個人情報の管理',
    content: `当サイトは、ご利用者様の個人データへの不正なアクセスや漏洩、滅失、毀損等を防止するため、必要な安全対策を講じます。\nまた、保有を継続しない個人情報は、適切な方法で確実に廃棄または消去します。`,
  },
  {
    title: '5．プライバシーポリシーの変更および告知について',
    content: `当サイトのプライバシーポリシーの内容は、必要に応じて変更することがありますが、その都度ご利用者様に個別のご連絡はいたしません。\nご利用の際には当ウェブサイトの最新の内容をご参照ください。`,
  },
  {
    title: '6．ご利用者様の個人データ照会',
    content: `当サイトに保有されているご利用者様の個人データについて、ご利用者様ご自身が照会、修正、追加、利用停止、消去の各請求を要望される場合は、ご本人であることを確認の上、対応させていただきます。`,
  },
  {
    title: '7．免責',
    content: `当サイトにリンクされている他のWEBサイトにおけるご利用者様の個人情報等の保護、取扱い等については、一切の責任を負うものではありません。`,
  },
  {
    title: '8．アクセス解析ツールの利用について',
    content: `当サイトでは、利用者の閲覧状況を把握し、サービス改善の参考とするために、Google アナリティクス（GA4）を利用しています。Google アナリティクスはCookieや類似技術を使用してデータを収集しますが、これには個人を特定する情報は含まれません。\nデータ収集・処理の仕組みについては、Googleの規約をご確認ください。`,
    links: [
      { label: 'Googleによる情報使用の仕組み', href: 'https://policies.google.com/technologies/partner-sites?hl=ja' },
      { label: 'Google アナリティクス利用規約', href: 'https://marketingplatform.google.com/about/analytics/terms/jp/' },
    ],
  },
  {
    title: '9．コンテンツ作成ポリシーについて',
    content: `当社は、お客様に信頼性の高い情報を提供するため、独自の編集体制とコンテンツ作成の方針を定めています。`,
  },
  {
    title: '10．お問い合わせ先',
    content: `当社の個人情報に関するお問い合わせ先は、下記までお願い致します。`,
    contact: true,
  },
];

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero */}
      <section className="pt-32 pb-16 md:pt-40 md:pb-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <span className="inline-flex items-center border border-stone-400 text-stone-500 text-xs tracking-widest px-4 py-1.5 rounded-full w-fit mb-6">
            PRIVACY POLICY
          </span>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-light text-stone-900 tracking-wide leading-tight">
            プライバシーポリシー
          </h1>
          <p className="mt-4 text-stone-500 text-sm leading-relaxed max-w-2xl">
            株式会社AMYMAISON（以下「当社」）では、以下のとおり個人情報保護方針を定め、ご利用者様の個人情報の適切な保護に努めます。
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <div className="flex flex-col gap-12">
            {sections.map((section) => (
              <div
                key={section.title}
                className="flex flex-col gap-4 border-b border-stone-100 pb-12 last:border-none last:pb-0"
              >
                <h2 className="text-base md:text-lg font-medium text-stone-900 tracking-wide">
                  {section.title}
                </h2>
                {section.content && (
                  <p className="text-stone-600 text-sm leading-loose whitespace-pre-line">
                    {section.content}
                  </p>
                )}
                {section.links && (
                  <ul className="flex flex-col gap-2 mt-1">
                    {section.links.map((link) => (
                      <li key={link.label}>
                        <a
                          href={link.href}
                          target="_blank"
                          rel="nofollow noopener noreferrer"
                          className="text-stone-500 text-sm underline underline-offset-4 hover:text-stone-800 transition-colors duration-200 cursor-pointer"
                        >
                          {link.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
                {section.contact && (
                  <div className="flex flex-col gap-6 mt-2">
                    <div className="flex flex-col gap-2">
                      <p className="text-stone-700 text-sm font-medium tracking-wide">【Webの場合】</p>
                      <p className="text-stone-600 text-sm leading-relaxed">
                        お問い合わせフォームよりお問い合わせ下さい。
                      </p>
                    </div>
                    <div className="flex flex-col gap-2">
                      <p className="text-stone-700 text-sm font-medium tracking-wide">【郵送の場合】</p>
                      <p className="text-stone-600 text-sm leading-relaxed">
                        所在地：〒〇〇〇-〇〇〇〇 〇〇県〇〇市〇〇町〇-〇-〇 〇〇ビル〇階<br />
                        株式会社AMYMAISON　個人情報お問い合わせ窓口
                      </p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Back */}
      <section className="py-12 md:py-16 border-t border-stone-100">
        <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-stone-600 text-sm tracking-widest hover:text-stone-900 transition-colors duration-300 cursor-pointer"
          >
            <i className="ri-arrow-left-line" />
            トップページに戻る
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
